// extracted by mini-css-extract-plugin
export default {"job-event-list-modal":"style_job-event-list-modal__87ntn","jobEventListModal":"style_job-event-list-modal__87ntn"};